import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';

class SecBanner extends Component {
  
  handelClickBanner = () => {
    const navigate = useNavigate();
    navigate('/Today', { state: { tab: 2 } });
  }
  render() {
    return (
      <section className="section">
        <a href="/TodayCross" className="quiz-banner quiz-banner--index">
          <div className="img-bx">
            <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32.9879 72.4679V88.6135C32.9879 90.387 33.609 91.8965 34.8511 93.1421C36.0967 94.3842 37.608 95.0053 39.385 95.0053H55.52C57.297 95.0053 58.8083 94.3842 60.0539 93.1421C61.296 91.8965 61.917 90.387 61.917 88.6135V72.4679C61.917 70.691 61.296 69.1797 60.0539 67.9341C58.8083 66.6919 57.297 66.0709 55.52 66.0709H39.385C37.608 66.0709 36.0967 66.6919 34.8511 67.9341C33.609 69.1797 32.9879 70.691 32.9879 72.4679ZM28.9238 55.615V39.48C28.9238 37.703 28.3028 36.1935 27.0607 34.9514C25.8186 33.7058 24.309 33.0829 22.5321 33.0829H6.39702C4.62007 33.0829 3.10878 33.7058 1.86316 34.9514C0.621053 36.197 0 37.7065 0 39.48V55.6203C0 57.3937 0.621053 58.9033 1.86316 60.1489C3.10878 61.391 4.61831 62.0121 6.39174 62.0121H22.5374C24.3143 62.0121 25.8256 61.391 27.0712 60.1489C28.3133 58.9033 28.9344 57.3937 28.9344 55.6203M39.385 62.0121H55.5253C57.3023 62.0121 58.8135 61.391 60.0592 60.1489C61.3013 58.9033 61.9223 57.3937 61.9223 55.6203V39.48C61.9223 37.703 61.3013 36.1935 60.0592 34.9514C58.8135 33.7058 57.3023 33.0829 55.5253 33.0829H39.3902C37.6133 33.0829 36.102 33.7058 34.8564 34.9514C33.6143 36.1935 32.9932 37.703 32.9932 39.48V55.6203C32.9932 57.3937 33.6143 58.9033 34.8564 60.1489C36.102 61.391 37.6133 62.0121 39.3902 62.0121M72.3676 29.0241H88.6083C90.3817 29.0241 91.8912 28.4031 93.1368 27.161C94.3789 25.9153 95 24.4058 95 22.6324V6.39702C95 4.62007 94.3789 3.10878 93.1368 1.86316C91.8947 0.621053 90.387 0 88.6135 0H72.3623C70.5889 0 69.0794 0.621053 67.8338 1.86316C66.5917 3.10878 65.9706 4.61831 65.9706 6.39174V22.6324C65.9706 24.4093 66.5917 25.9206 67.8338 27.1662C69.0794 28.4083 70.5907 29.0294 72.3676 29.0294" fill="white" />
              <rect x="66" y="33" width="29" height="29" rx="6" fill="#00FF99" />
            </svg>
          </div>
          <></>
          <div className="txt-bx">
            <h2 className="title"> 주간 <em>십자말풀이</em> </h2>
            <p className="desc"> 이번주 십자말풀이 도전해보세요! </p>
            <p className="go">
              지금 도전하기
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6.6 1.40269L12.2 7.00269H0V9.00269H12.2L6.6 14.6027L8 16.0027L16 8.00269L8 0.00268555L6.6 1.40269Z" fill="white" />
              </svg>
            </p>
          </div>
        </a>
      </section>

    );
  }
}

export default SecBanner;    